// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1PLLp","addWidgetButton":"Header_addWidgetButton__2v9pn","dashboardTabs":"Header_dashboardTabs__AJxbJ","active":"Header_active__2iHW5"};